import React from 'react';
import { Link } from 'react-router-dom';
const GradientOutlineButton = ({
  onClick,
  text,
  isDark,
  width,
  height,
  navigateTo,
}) => {
  const containerClasses = `gradientBorder items-center justify-center cursor-pointer hover:bg-primary group select-none rounded-md hover:before:hidden transition-all duration-300 transform hover:scale-105 ${height} ${
    width || 'w-full sm:w-fit'
  }`;

  // If navigateTo is provided and it's an internal link, use Link
  if (navigateTo && !navigateTo.startsWith('http')) {
    return (
      <Link to={navigateTo} className={containerClasses}>
        <p
          className={`${
            isDark ? 'text-white' : 'text-primary'
          } group-hover:text-white font-semibold text-[16px] sm:text-[20px] text-center `}
        >
          {text}
        </p>
      </Link>
    );
  }

  // For external links or onClick handlers, use div
  const handleClick = () => {
    if (navigateTo?.startsWith('http')) {
      window.open(navigateTo, '_blank');
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <div className={containerClasses} onClick={handleClick}>
      <p
        className={`${
          isDark ? 'text-white' : 'text-primary'
        } group-hover:text-white font-semibold text-[16px] sm:text-[20px] text-center `}
      >
        {text}
      </p>
    </div>
  );
};

export default GradientOutlineButton;
